import { getNext3Months } from '@/core/utils/getNext3Months.ts'
import {
  PlanItem,
  PlannedItem,
  Product,
} from '@/data/replenishmentPlan/slice/replenishmentPlan.types.ts'
import { getPlanFormattedDateFromDate } from '@/core/utils/getPlanFormattedDateFromDate.ts'

const getProductsCostForNext3Months = (
  products: Product[],
  plannedItems: PlanItem<PlannedItem>,
): number => {
  const next3months = getNext3Months()

  let sum = 0

  for (const month of next3months) {
    const planFormattedDate = getPlanFormattedDateFromDate(month)

    for (const product of products) {
      const productPlannedItem = plannedItems[product.id]

      if (!productPlannedItem) {
        continue
      }

      const monthPlanItem = productPlannedItem[planFormattedDate]

      if (monthPlanItem) {
        sum += monthPlanItem.amount * product.price
      }
    }
  }

  return sum
}

export { getProductsCostForNext3Months }
